import { format } from 'date-fns';

export enum SlackPushTypes {
  ResidualExchanges = 'RESIDUAL_EXCHANGES',
  ExchangeAssistance = 'EXCHANGE_ASSISTANCE',
  TextAlertByFront = 'TEST_ALERT'
}

export const SlackPushTypesTitle = {
  [SlackPushTypes.ResidualExchanges]: ':alert::alert::alert: Changes With Residual Values :alert::alert::alert:',
  [SlackPushTypes.TextAlertByFront]: ':alert::alert::alert: Test Alert By Front :alert::alert::alert:'
};

export const SlackPushTypesContext = {
  [SlackPushTypes.ResidualExchanges]: `*${format(new Date(), 'MMMM dd, yyyy')}* | Travel Support Alert`
};

export const USER_ITINERARY_INFO_LABEL = ':information_source: *USER ITINERARY INFO* :information_source:';
export const RESERVATION_FLIGHT_INFO_LABEL = ':airplane: *FLIGHT RESERVATION INFO* :airplane:';
export const RESERVATION_EXCHANGE_VALUE_LABEL = ':moneybag: *FLIGHT CHANGE VALUES* :moneybag:';
